import {Subscription} from 'rxjs';

export class Subscriptions {
    static unsubscribeAll(subscriptions: Array<Subscription>) {
        subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
